<template>

    <div>

        <app-head :title="supplier.name" />

        <div class="text-white bg-light p-5 position-relative">
            <div class="container">
                <div class="row text-dark">
                    <div class="col">
                        <h1 class="display-3">
                            {{ supplier.name }}
                        </h1>
                        <div class="" v-if="supplier.description" v-html="supplier.description">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container my-5">
            <!--<breadcrumbs />-->
            <!--<filters :filters="filters" />-->
        </div>

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <div class="">

                        <iframe src="https://caddent.de/online-auftraege/bestellablauf/" width="100%" height="800px" scrolling="auto">
                        </iframe>

                    </div>

                </div>

                <div class="col-lg-4">

                    <supplier-details
                        :supplier="supplier"
                        :is-favorite-supplier="isFavoriteSupplier"
                        />

                </div>

            </div>

        </div>

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Filters from '@/shared/Filters';
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    import SupplierDetails from './SupplierDetails';

    export default {
        props: [
            'filters',
            'supplier',
            'products',
            'isFavoriteSupplier',
        ],
        components: {
            Results,
            Filters,
            Pagination,
            Breadcrumbs,
            ProductList,
            SupplierDetails,
        }
    }
</script>